import React from 'react'
import PropTypes from 'prop-types'

const Button = ({ onClick, type = 'button', className, children }) => (
	<button onClick={onClick} className={className} type={type}>
		{children}
	</button>
)

Button.propTypes = {
	onClick: PropTypes.func,
	type: PropTypes.string,
	className: PropTypes.string.isRequired,
	children: PropTypes.node,
}

export default Button